import { render, staticRenderFns } from "./receber.vue?vue&type=template&id=3a99dbef"
import script from "./receber.vue?vue&type=script&lang=js"
export * from "./receber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports